import { render, staticRenderFns } from "./form-recruiter.vue?vue&type=template&id=9d2bc98a"
import script from "./form-recruiter.vue?vue&type=script&lang=js"
export * from "./form-recruiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports